import type { Composition } from '@shared/types'
import { useEditorStore } from '../../../store/editorStore'
import { overlaysForLane } from '../../../lib/timelineMath'
import { OverlayBar } from './OverlayBar'
import { OVERLAY_LANE_ORDER, overlayLaneHeight } from './constants'

/**
 * task spec §2-9: Overlay を種類別に 4 レーン（カード/ラベル/ロゴ/テキスト）へ分離。
 * 空レーンは `overlayLaneHeight` が細い高さを返すのでそのまま反映される。
 */
export function OverlayLane({ composition, pxPerSec }: { composition: Composition; pxPerSec: number }) {
  const selectedIds = useEditorStore((s) => s.selectedIds)
  const select = useEditorStore((s) => s.select)
  const overlays = composition.tracks.overlays
  const logo = overlays.find((o) => o.kind === 'logo')
  const logoSelected = !!logo && selectedIds.some((s) => s.kind === 'overlay' && s.id === logo.id)

  return (
    <div data-testid="overlay-lane">
      {OVERLAY_LANE_ORDER.map((lane) => {
        const h = overlayLaneHeight(overlays, lane.key)
        if (lane.key === 'logo') {
          return (
            <div
              key={lane.key}
              className="relative border-b border-ink-border/30"
              style={{ height: h }}
              data-testid="overlay-sublane-logo"
              onClick={(e) => {
                if (e.target === e.currentTarget) select(null)
              }}
            >
              {logo && (
                <div
                  onClick={() => select({ kind: 'overlay', id: logo.id })}
                  className={`absolute inset-y-0.5 left-1 right-1 rounded bg-[#8FA0B8]/60 flex items-center px-1.5 text-[9px] text-black/80 cursor-pointer border ${
                    logoSelected ? 'border-white' : 'border-transparent'
                  }`}
                  data-testid="overlay-logo-chip"
                  title="ロゴ（常時表示・startSec/durationSec を持たない）"
                >
                  ロゴ（常時表示）
                </div>
              )}
            </div>
          )
        }
        const laneOverlays = overlaysForLane(overlays, lane.key)
        return (
          <div
            key={lane.key}
            className="relative border-b border-ink-border/30"
            style={{ height: h }}
            data-testid={`overlay-sublane-${lane.key}`}
            onClick={(e) => {
              if (e.target === e.currentTarget) select(null)
            }}
          >
            {laneOverlays.map((o) => (
              <OverlayBar
                key={o.id}
                overlay={o}
                pxPerSec={pxPerSec}
                selected={selectedIds.some((s) => s.kind === 'overlay' && s.id === o.id)}
              />
            ))}
          </div>
        )
      })}
    </div>
  )
}
